<script setup>
import { useRouter } from 'vue-router'
import { authStore } from '@/stores/auth.js'
const router = useRouter()
async function logout() {
  await authStore.logout()
  await router.replace('/login')
}
</script>

<template>
  <section class="workspace-placeholder" aria-labelledby="review-title">
    <div class="workspace-badge" aria-hidden="true">审</div>
    <p class="eyebrow">SAFE WORKSPACE RECOVERY</p>
    <h1 id="review-title">项目资料需要安全复核</h1>
    <p>系统发现当前账号没有可安全确认的唯一项目，因此已停止自动选择。你的企业数据没有被删除、归档或合并。</p>
    <p class="status-note">请联系技术支持复核历史资料归属；不需要企业管理员把其他项目分配给此账号。</p>
    <button class="text-button" type="button" @click="logout">退出登录</button>
  </section>
</template>
